module.exports = __webpack_public_path__ + "static/media/undraw_Emails_re_cqen.ed4c4d17.svg";